import React from 'react';
import useMountedQuery from 'Hooks/useMountedQuery';
import { getProgramRules } from 'Queries/GraphQlQueries/ProgramRule/ProgramRuleQueries';

/**
 * Get all program rules for a given program version
 * @param programVersionId
 */
const useGetProgramRules = (programVersionId?: string) => {
	return useMountedQuery(
		abortSignal => getProgramRules(abortSignal, programVersionId!),
		[programVersionId],
		() => {},
		!programVersionId,
	);
};

export default useGetProgramRules;
